import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="relative w-full bg-foreground-950 py-16 md:py-20 px-4 md:px-6">
      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end gap-6 mb-12">
          <span className="inline-flex items-center px-4 py-1.5 border border-background-50/20 text-background-50 rounded-full text-xs whitespace-nowrap w-fit">
            Categorias
          </span>
          <h2 className="font-heading text-3xl md:text-5xl text-background-50 leading-tight max-w-2xl">
            Explore nossa coleção de links organizados
          </h2>
        </div>

        {/* First row - 8 main categories */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 mb-4">
          {categories.slice(0, 8).map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex items-center gap-4 bg-background-50/5 border border-background-50/10 rounded-2xl p-4 hover:bg-background-50/10 hover:border-background-50/20 transition-all duration-200 cursor-pointer overflow-hidden"
            >
              {/* Product Thumbnail */}
              <div className="w-14 h-14 rounded-xl flex-shrink-0 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.namePt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-background-50 font-medium text-sm mb-0.5 truncate">{cat.name}</h3>
                <p className="text-background-50/50 text-xs">{cat.count}+ links</p>
              </div>
              <i className="ri-arrow-right-s-line text-background-50/30 text-base w-4 h-4 flex items-center justify-center flex-shrink-0 group-hover:text-background-50/60 transition-colors duration-200"></i>
            </a>
          ))}
        </div>

        {/* Second row - remaining 6 categories */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.slice(8).map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-3 bg-background-50/5 border border-background-50/10 rounded-2xl p-4 hover:bg-background-50/10 hover:border-background-50/20 transition-all duration-200 cursor-pointer overflow-hidden"
            >
              {/* Product Thumbnail */}
              <div className="w-full h-28 rounded-xl overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.namePt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <div className="text-center">
                <h3 className="text-background-50/90 text-xs font-medium mb-0.5">{cat.name}</h3>
                <p className="text-background-50/40 text-[10px]">{cat.count}+</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}